import { LIST_STATUS } from 'constants/ManagerCandidate';
import { TRIGGER_TYPE, SEND_MODE, MAIL_LOG_STATUS } from 'constants/MailTemplate';

const MINUTES_PER_HOUR = 60;
const MINUTES_PER_DAY = 1440;

export const getApplyStatusName = (status) => LIST_STATUS.find((item) => item.id === status)?.name || '';

export const getMailTriggerText = (t, template) => {
  switch (template?.trigger_type) {
    case TRIGGER_TYPE.APPLY_STATUS:
      return t('managerMailTemplate.triggerApplyStatus', { status: getApplyStatusName(template.trigger_status) });
    case TRIGGER_TYPE.INTERVIEW_UPDATED:
      return t('managerMailTemplate.triggerInterviewUpdated');
    default:
      return t('managerMailTemplate.triggerManual');
  }
};

// 10080 -> "7 ngày", 90 -> "1 giờ 30 phút"
export const getDelayText = (t, minutes) => {
  const value = Number(minutes) || 0;
  if (!value) return t('managerMailTemplate.sendNow');
  const days = Math.floor(value / MINUTES_PER_DAY);
  const hours = Math.floor((value % MINUTES_PER_DAY) / MINUTES_PER_HOUR);
  const mins = value % MINUTES_PER_HOUR;
  return [
    days && t('managerMailTemplate.days', { count: days }),
    hours && t('managerMailTemplate.hours', { count: hours }),
    mins && t('managerMailTemplate.minutes', { count: mins }),
  ]
    .filter(Boolean)
    .join(' ');
};

export const getSendModeText = (t, template) => {
  switch (template?.send_mode) {
    case SEND_MODE.AUTO:
      return t('managerMailTemplate.sendModeAutoAfter', { delay: getDelayText(t, template.delay_minutes) });
    case SEND_MODE.CONFIRM:
      return t('managerMailTemplate.sendModeConfirm');
    default:
      return t('managerMailTemplate.sendModeManual');
  }
};

export const getMailLogStatusText = (t, status) => {
  switch (status) {
    case MAIL_LOG_STATUS.PENDING:
      return t('candidateMail.logPending');
    case MAIL_LOG_STATUS.SENDING:
      return t('candidateMail.logSending');
    case MAIL_LOG_STATUS.SENT:
      return t('candidateMail.logSent');
    case MAIL_LOG_STATUS.FAILED:
      return t('candidateMail.logFailed');
    default:
      return t('candidateMail.logCancelled');
  }
};

// Mã lý do BE ghi vào mail_logs.note (MailTemplateEnum::NOTE_*); lỗi SMTP thì note là message gốc
const LIST_MAIL_LOG_NOTE = [
  'invalid_email',
  'dry_run_no_recipient',
  'not_in_whitelist',
  'status_changed',
  'template_inactive',
  'apply_not_found',
  'rollback_status',
  'candidate_mail_disabled',
];

export const getMailLogNoteText = (t, note) => {
  if (!note) return '';
  return LIST_MAIL_LOG_NOTE.includes(note) ? t(`candidateMail.note.${note}`) : note;
};
